
<template>
  <div
    class="collection-filters"
    :class="{ 'collection-filters--fixed' : isFixed }"
    v-if="$mq !== 'mobile' && $mq !== 'tablet' && filterGroups.length"
    ref="filterContainer">
    <h4 class="collection-filters__heading h7">Filter</h4>
    <div class="collection-filters__filter-menu">
      <div class="collection-filters__filter-panels">
        <div
          class="collection-filters__filter-panel"
          v-for="filterGroup in filterGroups"
          :key="filterGroup.name"
        >
          <collection-accordion-b
            :ref="`accordion${filterGroup.name}`"
            iconSize="14px"
            activeIcon="minus"
            inactiveIcon="plus"
          >
            <template v-slot:heading>
              {{unhandleizeFilter(filterGroup.name)}}
              <span
                class="collection-filters__current-filter-count"
                v-if="containsCurrentFilters(filterGroup.name)"
              >{{currentFilterCount(filterGroup.name)}}</span>
            </template>
            <template v-slot>
              <div
                class="collection-filters__filter-panel-filters"
                v-if="filterGroup.name === 'color'"
              >
                <div
                  class="collection-filters__filter-panel-filter-color-swatch"
                  v-for="color in returnExpandedUnexpanded(filterGroup.name)"
                  :key="`${filterGroup.name}-${color}`"
                >
                  <input
                    class="collection-filters__filter-panel-filter-color-swatch-checkbox"
                    :id="`${filterGroup.name}-${color}`"
                    :value="`${filterGroup.name}-${color}`"
                    type="checkbox"
                    :checked="currentFilterArray.indexOf(`${filterGroup.name}-${color}`) >= 0"
                    @change="updateFilterArray"
                    :style="`backgroundImage: url(${getFileUrl(`swatch_${handleizedFilter(color)}.png`)})`"
                  />
                  <label :for="`${filterGroup.name}-${color}`">{{color}}</label>
                </div>
              </div>
              <div
                class="collection-filters__filter-panel-filters"
                v-if="filterGroup.name === 'pattern'"
              >
                <div
                  class="collection-filters__filter-panel-filter-color-swatch"
                  v-for="pattern in returnExpandedUnexpanded(filterGroup.name)"
                  :key="`${filterGroup.name}-${pattern}`"
                >
                  <input
                    class="collection-filters__filter-panel-filter-color-swatch-checkbox"
                    :id="`${filterGroup.name}-${pattern}`"
                    :value="`${filterGroup.name}-${pattern}`"
                    type="checkbox"
                    :checked="currentFilterArray.indexOf(`${filterGroup.name}-${pattern}`) >= 0"
                    @change="updateFilterArray"
                    :style="`backgroundImage: url(${getFileUrl(`swatch_${handleizedFilter(pattern)}.png`)})`"
                  />
                  <label :for="`${filterGroup.name}-${pattern}`">{{pattern}}</label>
                </div>
              </div>
              <div
                class="collection-filters__filter-panel-filters"
                v-if="filterGroup.name !== 'color' && filterGroup.name !== 'pattern'"
              >
                <div
                  class="collection-filters__filter-panel-filter"
                  v-for="filter in returnExpandedUnexpanded(filterGroup.name)"
                  :key="`${filterGroup.name}-${filter}`"
                >
                  <input
                    :id="`${filterGroup.name}-${filter}`"
                    :value="`${filterGroup.name}-${filter}`"
                    type="checkbox"
                    :checked="currentFilterArray.indexOf(`${filterGroup.name}-${filter}`) >= 0"
                    @change="updateFilterArray"
                  />
                  <label :for="`${filterGroup.name}-${filter}`">{{filter}}</label>
                </div>
              </div>
              <span
                class="collection-filters__filter-panel-filters-show-more-less link-text"
                v-if="filterGroup.allTags.length > 5"
                @click="toggleExpand(filterGroup.name, `accordion${filterGroup.name}`)"
              >{{isExpanded(filterGroup.name) ? 'See Less &minus;' : 'See More &plus;'}}</span>
            </template>
          </collection-accordion-b>
        </div>
      </div>
    </div>
  </div>
  <div class="collection-filters" v-else>
    <div
      class="collection-filters__filter-accordion"
      v-for="filterGroup in filterGroups"
      :key="filterGroup.name"
    >
      <div
        class="collection-filters__filter-accordion-header"
        @click="setCurrentMobileFilter(filterGroup.name)"
      >
        <div class="collection-filters__filter-accordion-title body-md">
          <span
            class="collection-filters__filter-accordion-title-span body-sm"
          >{{unhandleizeFilter(filterGroup.name)}}</span>
          <span
              class="collection-filters__current-filter-count"
              v-if="containsCurrentFilters(filterGroup.name)"
            >{{currentFilterCount(filterGroup.name) > 0 ? `${currentFilterCount(filterGroup.name)}` : ''}}</span>
        </div>
        <icon v-if="currentFilterPanel !== filterGroup.name" name="plus" size="14px"></icon>
        <icon v-if="currentFilterPanel === filterGroup.name" name="minus" size="14px"></icon>
      </div>
      <collapse-transition>
        <div
          class="collection-filters__filter-panel-filters row"
          v-if="filterGroup.name === 'color' && currentFilterPanel === filterGroup.name"
        >
          <div
            class="collection-filters__filter-panel-filter-color-swatch"
            v-for="color in filterGroup.allTags"
            :key="`${filterGroup.name}-${color}`"
          >
            <input
              class="collection-filters__filter-panel-filter-color-swatch-checkbox"
              :id="`${filterGroup.name}-${color}`"
              :value="`${filterGroup.name}-${color}`"
              type="checkbox"
              :checked="currentFilterArray.indexOf(`${filterGroup.name}-${color}`) >= 0"
              @change="updateFilterArray"
              :style="`backgroundImage: url(${getFileUrl(`swatch_${handleizedFilter(color)}.png`)})`"
            />
            <label class="body-sm" :for="`${filterGroup.name}-${color}`">{{color}}</label>
          </div>
        </div>
      </collapse-transition>
      <collapse-transition>
        <div
          class="collection-filters__filter-panel-filters row"
          v-if="filterGroup.name === 'pattern' && currentFilterPanel === filterGroup.name"
        >
          <div
            class="collection-filters__filter-panel-filter-color-swatch"
            v-for="pattern in filterGroup.allTags"
            :key="`${filterGroup.name}-${pattern}`"
          >
            <input
              class="collection-filters__filter-panel-filter-color-swatch-checkbox"
              :id="`${filterGroup.name}-${pattern}`"
              :value="`${filterGroup.name}-${pattern}`"
              type="checkbox"
              :checked="currentFilterArray.indexOf(`${filterGroup.name}-${pattern}`) >= 0"
              @change="updateFilterArray"
              :style="`backgroundImage: url(${getFileUrl(`swatch_${handleizedFilter(pattern)}.png`)})`"
            />
            <label :for="`${filterGroup.name}-${pattern}`">{{pattern}}</label>
          </div>
        </div>
      </collapse-transition>
      <collapse-transition>
        <div
          class="collection-filters__filter-panel-filters column"
          v-if="currentFilterPanel === filterGroup.name && currentFilterPanel !== 'color' && currentFilterPanel !== 'pattern'"
        >
          <div
            class="collection-filters__filter-panel-filter"
            v-for="filter in filterGroup.allTags"
            :key="`${filterGroup.name}-${filter}`"
          >
            <input
              class="collection-filters__filter-panel-filter-checkbox"
              :id="`${filterGroup.name}-${filter}`"
              :value="`${filterGroup.name}-${filter}`"
              type="checkbox"
              :checked="currentFilterArray.indexOf(`${filterGroup.name}-${filter}`) >= 0"
              @change="updateFilterArray"
            />
            <label class="body-sm" :for="`${filterGroup.name}-${filter}`">{{filter}}</label>
          </div>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapState } from 'vuex';
import { FadeTransition, CollapseTransition } from 'vue2-transitions';

import { handleize, unhandleize } from '@/scripts/filters/string.js';
import { fileUrl, scrollToElement } from '@/scripts/helpers/util';
import { scrollToId } from '@/scripts/helpers/scroll.js';

import Icon from '@/scripts/components/basic/Icon.vue';
import VLink from '@/scripts/components/buttons/VLink.vue';
import CollectionAccordionB from './CollectionAccordionB.vue';
import CollectionActiveFiltersB from './CollectionActiveFiltersB.vue';

export default {
  name: 'CollectionFiltersB',
  components: {
    VLink,
    Icon,
    FadeTransition,
    CollapseTransition,
    CollectionAccordionB,
    CollectionActiveFiltersB,
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentFilterArray: [],
      currentFilterPanel: '',
      filterPanelOpen: false,
      expandedFilters: [],
      isFixed: false,
    };
  },
  computed: {
    ...mapState({
      currentFilters: (state) => state.collections.currentFilters,
    }),
    splitTags() {
      return this.tags.map((tag) => {
        const valueArray = tag.split('::');
        return { tag: handleize(valueArray[0]), value: valueArray[1] };
      });
    },
    filterGroups() {
      const filterGroups = [];
      this.filtersWithoutDuplicates.forEach((filter) => {
        const filterGroup = {
          name: filter,
          lessTags: [],
          allTags: [],
        };

        this.splitTags.forEach((tag) => {
          if (tag.tag === filter && tag.value) {
            filterGroup.allTags.push(tag.value);
          }
        });

        if (filter === 'price') {
          filterGroup.allTags.sort((a, b) => {
            const valA = parseInt(a.slice(1));
            const valB = parseInt(b.slice(1));

            return (isNaN(valA) ? 0 : valA) - (isNaN(valB) ? 0 : valB);
          });
        }

        filterGroup.lessTags = filterGroup.allTags.slice(0, 5);

        filterGroups.push(filterGroup);
      });
      return filterGroups;
    },
    currentFilterArrayUnhandelized() {
      return this.currentFilterArray.map((filter) => {
        return unhandleize(filter);
      });
    },
    filtersWithoutDuplicates() {
      const filters = [...new Set(this.filters)];
      return filters;
    },
  },
  methods: {
    updateFilterArray(e) {
      const { value } = e.target;
      const filterName = value.split('-')[0];
      const matchingFilter = this.currentFilterArray.filter((filter) => {
        // Only one of brand or pattern can be selected
        if (['brand', 'pattern'].indexOf(filterName) >= 0) {
          return ['brand', 'pattern'].indexOf(filter.split('-')[0]) >= 0;
        } else {
          return filter.split('-')[0] === filterName;
        }
      });
      const productGridPosition = document.getElementById('shopify-section-collection-grid').offsetTop;
      window.scrollTo({top: productGridPosition - 90, behavior:'smooth'});
      if (this.currentFilterArray.indexOf(value) >= 0) {
        this.removeFilter(value);
      } else {
        if (matchingFilter.length > 0) {
          this.removeFilter(matchingFilter[0]);
        }
        this.currentFilterArray.push(value);
      }
    },
    unhandleizeFilter(handleizedFilter) {
      return unhandleize(handleizedFilter);
    },
    handleizedFilter(unhandelizedFilter) {
      return handleize(unhandelizedFilter, false);
    },
    removeFilter(filter) {
      this.currentFilterArray.splice(
        this.currentFilterArray.indexOf(filter),
        1
      );
    },
    removeAllFilters() {
      this.currentFilterArray = [];
    },
    getFileUrl(file) {
      return fileUrl(file);
    },
    setCurrentFilterPanel(filter) {
      if (this.currentFilterPanel === filter) {
        this.currentFilterPanel = '';
        this.$forceUpdate();
        this.filterPanelOpen = !this.filterPanelOpen;
      } else if (!this.filterPanelOpen) {
        this.currentFilterPanel = filter;
        this.$forceUpdate();
        this.filterPanelOpen = !this.filterPanelOpen;
      } else {
        this.currentFilterPanel = filter;
        this.$forceUpdate();
      }
    },
    setCurrentMobileFilter(filter) {
      if (filter === this.currentFilterPanel) {
        this.currentFilterPanel = '';
        this.$forceUpdate();
      } else {
        this.currentFilterPanel = filter;
        this.$forceUpdate();
      }
    },
    isUseableFilter(currentFilter) {
      return this.splitTags.some((filter) => {
        return filter.tag === currentFilter;
      });
    },
    getMobilePanelFilters(filterName) {
      if (this.currentFilters.length) {
        const filters = this.currentFilters.map((filter) => {
          if (
            filter.includes(filterName) &&
            !filter.includes(`-${filterName}`)
          ) {
            return filter;
          }
          return '';
        });

        const activeFilters = filters.filter((filter) => filter !== '');

        if (activeFilters.length) {
          const unhandelizedFilters = activeFilters.map((filter) => {
            const replacedFilter = filter.replace(`${filterName}`, '');
            return unhandleize(replacedFilter);
          });
          const joinedFilters = unhandelizedFilters.join(', ').slice(0, 30);
          return `${joinedFilters}${joinedFilters.length >= 30 ? '...' : ''}`;
        }
        return '';
      }
      return '';
    },
    containsCurrentFilters(filterName) {
      if (this.currentFilters && this.currentFilters.length) {
        return this.currentFilters.some((filter) =>
          filter.startsWith(filterName)
        );
      }
    },
    currentFilterCount(filterName) {
      return this.currentFilters.filter((filter) =>
        filter.startsWith(filterName)
      ).length;
    },
    clearFilterFilters(filterName) {
      let newCurrentFilters = this.currentFilters;
      newCurrentFilters = newCurrentFilters.filter(
        (filter) => !filter.startsWith(filterName)
      );
      this.$store.dispatch('collections/updateFilters', newCurrentFilters);
    },
    toggleExpand(filterName, ref) {
      const currentFilterIndex = this.expandedFilters.findIndex(
        (filter) => filter.name === filterName
      );
      this.expandedFilters[currentFilterIndex].expanded = !this.expandedFilters[
        currentFilterIndex
      ].expanded;
      this.$refs[ref][0].addMaxHeight();
    },
    isExpanded(filterName) {
      const currentFilterIndex = this.expandedFilters.findIndex(
        (filter) => filter.name === filterName
      );
      return this.expandedFilters[currentFilterIndex].expanded;
    },
    returnExpandedUnexpanded(filterName) {
      const filterIndex = this.filterGroups.findIndex(
        (filter) => filter.name === filterName
      );
      if (this.isExpanded(filterName)) {
        return this.filterGroups[filterIndex].allTags;
      }
      return this.filterGroups[filterIndex].lessTags;
    },
    setFixedFilters () {
      if (!this.$refs.filterContainer) return;

      const parent = this.$refs.filterContainer.parentNode;
      const parentPosition = parent.getBoundingClientRect();

      this.isFixed = parentPosition.y < 125;
    }
  },
  watch: {
    currentFilterArray() {
      this.$store.dispatch(
        'collections/updateFilters',
        this.currentFilterArray
      );
    },
    currentFilters() {
      if (this.currentFilters !== this.currentFilterArray) {
        this.currentFilterArray = this.currentFilters;
      }
    },
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'updateFilters') {
        this.currentFilterArray = this.currentFilters;
      }
    });

    const resizeFunc = debounce(() => this.setFixedFilters(), 10);
    document.addEventListener('scroll', resizeFunc);

    this.currentFilterArray = this.$store.state.collections.currentFilters
  },
  created() {
    const expandedFilters = this.filterGroups.map((filterGroup) => {
      return {
        name: filterGroup.name,
        expanded: false,
      };
    });
    this.expandedFilters = expandedFilters;
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<style scoped lang="scss">
.collection-filters {
  margin-left: auto;
  @include mobile-tablet {
    margin-left: 0;
    &:not(.collection-grid__filters) {
      border-bottom: 1px solid $color-light-grey;
    }
  }

  &.collection-filters--fixed {
    @include desktop-up {
      position: sticky;
      top: 125px;
      padding-bottom: 20px;
      width: 294px;
      max-height: calc(100vh - 125px);
      overflow-y: auto;
      opacity: 1;
    }
  }

  &__heading {
    margin-bottom: 16px;
    text-transform: uppercase;
    line-height: 20px;
    letter-spacing: 0.8px;
  }

  &__filter-menu {
    &-item {
      width: 100%;
      cursor: pointer;
      display: flex;
      align-items: center;
      transition: transform 300ms ease-in-out, color 200ms ease;
      span {
        margin-right: 4px;
        -webkit-font-smoothing: antialiased;
      }
      /deep/ .icon {
        transition: transform 300ms ease-in-out, color 200ms ease;
      }
      &:hover {
        /deep/ .icon {
          transform: translate3d(0, -1px, 0);
        }
      }
    }
    &-item.panel-active {
      position: relative;
      color: $color-brand-tertiary;
      /deep/ .icon {
        fill: $color-brand-tertiary;
        transform: rotate(-180deg);
      }
      &::after {
        position: absolute;
        left: 45%;
        bottom: -18px;
        content: '';
        width: 24px;
        height: 16px;
        background: $color-lightest-grey;
        -webkit-clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
      }
    }
    @media (max-width: 1260px) {
      margin-top: 0;
      margin-bottom: 16px;
      justify-content: center;
      &-item {
        margin-left: 0;
        margin-right: 40px;
      }
      &-item:last-child {
        margin-right: 0;
      }
    }
  }

  &__filter-accordion-header {
    position: relative;
  }

   &__current-filter-count {
     display: flex;
     justify-content: center;
     align-items: center;
     text-align: center;
     width: 24px;
     height: 24px;
     line-height: 24px;
     font-size: 12px;
     position: absolute;
     right: 30px;
     top: 50%;
     transform: translateY(-50%);
     background-color: $color-filter-count-bg;
     color: $color-black;
     padding: 4px;
     border-radius: 100%;
     font-family: $font-family-secondary;

     @include desktop-up {
       right: 50px;
     }
   }
  &__filter-panel-clear-filters {
    display: block;
    margin-bottom: 16px;
    cursor: pointer;
    color: $color-brand-primary;
    &:hover {
      text-decoration: underline;
    }
  }
  &__filter-panel {
    border-bottom: 1px solid $color-off-white;
    &:first-child {
      border-top: 1px solid $color-off-white;
    }
    &-filters {
      display: flex;
      flex-direction: column;
    }
    &-filter-color-swatch {
      display: flex;
      width: 100%;
      margin-bottom: 12px;
      align-items: center;
      &-checkbox {
        margin: 0;
        width: 30px;
        height: 30px;
        background-size: 150%;
        background-position: center;
        border-color: rgba(0, 0, 0, 0.1);
        flex-shrink: 0;
        border-radius: 1.5px;

        background: none;
        border: 1px solid $color-light-grey;
        &::after {
          content: '';
          display: block;
          background-image: none;
          width: 100%;
          height: 100%;
          border: 2px solid $color-white;
          border-radius: 0;
          top: 0%;
          left: 0%;
        }
        @include ie {
          &::-ms-check {
            display: none;
          }
        }
        // sorry for the important here, but the default input in the UI kit sets backgoround position to '0 0' and makes it look like the background of the swatch is moving. I didn't want to change that and break something else somewhere. This was a necessary important.
        &:hover {
          background-position: center !important;
        }
        &:checked {
          border: 1px solid $color-black;
          &::after {
            display: block;
            background-image: none;
            width: 100%;
            height: 100%;
            border: 2px solid white;
            border-radius: 0;
            top: 0%;
            left: 0%;
          }
        }
      }
      label {
        font-size: 1rem;
        padding-left: 8px;
      }
    }
    &-filter {
      display: flex;
      align-items: center;
      max-width: 220px;
      width: 100%;
      margin-bottom: 16px;
      &-checkbox {
        flex-shrink: 0;
      }
      label {
        margin-top: -2px;
      }
    }
  }
  &__filter-accordion {
    padding: 16px;
    border-bottom: 1px solid $color-light-grey;
    &-header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-title {
      &-span {
        @include h8;
        line-height: 16px;
      }
      &-active-filters {
        color: $color-grey;
        margin-left: 8px;
      }
    }
    .collection-filters__filter-panel-filters {
      padding: 0;
      justify-content: space-between;
      font-size: 12px;
      line-height: 20px;

      @include mobile-tablet {
        padding: 24px 0 0;
        display: flex;
        &.row {
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-start;
        }
      }
    }
    .collection-filters__filter-panel-filter-color-swatch {
      width: 100%;
      max-width: 140px;
      margin: 0 10px;
      text-align: left;
      flex-direction: row;
      &-checkbox {
        margin-right: 8px;
      }
      @include mobile-tablet {
        width: calc(50% - 20px);
        max-width: none;
        margin-bottom: 12px;
      }
    }
  }
  .collection-filters__filter-panel-filter {
    input {
      flex: 0 0 auto;
    }

    label {
      font-size: 12px;
      color: $color-black-700;
    }
  }
  &__active-filters {
    padding-top: 16px;
    display: flex;
    flex-wrap: wrap;
    @include mobile-tablet {
      padding: 12px;
    }
  }
  &__active-filter {
    display: flex;
    align-items: center;
    margin-right: 20px;
    padding-bottom: 12px;
    cursor: pointer;
    user-select: none;
    /deep/ .icon {
      transition: transform 200ms ease;
    }
    &:hover {
      /deep/ .icon {
        transform: scale3d(0.8, 0.8, 0.8);
      }
    }
  }
  &__filters-clear {
    cursor: pointer;
  }
  &__mobile-header {
    padding: 8px 16px;
    background-color: $color-light-grey;
    width: 100%;
    span {
      font-family: $font-family-secondary;
      font-size: 1rem;
      text-transform: uppercase;
    }
  }
  &__filter-panel-filters-show-more-less {
    display: inline-block;
    color: $color-brand-primary;
    margin-bottom: 8px;
    cursor: pointer;
    &-chevron {
      margin-left: 8px;
    }
    /deep/ .icon {
      fill: $color-brand-primary;
    }
  }
}
</style>
